import { defineStyleConfig } from '@chakra-ui/react'
import { themeColorSectionKeys } from '~/themes/colors/colors'

const { FontColor } = themeColorSectionKeys.defaults
export const LinkStyle = defineStyleConfig({
  baseStyle: {
    color: FontColor.Link,
    _hover: {
      textDecoration: 'underline',
    },
  },
})
